export const NAVIGATE_TO_THEME_DETAILS = 'NAVIGATE_TO_THEME_DETAILS';
export const REDIRECT_TO_URL = 'REDIRECT_TO_URL';
export const REDIRECT_TO_STRIPE_CHECKOUT = 'REDIRECT_TO_STRIPE_CHECKOUT';
export const STRIPE_CHECKOUT_ERROR = 'STRIPE_CHECKOUT_ERROR';